export type VisitorRegion = 'U.S.' | 'EU' | 'GCC' | 'Others';

const GCC_COUNTRIES = [
  'AE', // United Arab Emirates
  'BH', // Bahrain
  'DZ', // Algeria
  'EG', // Egypt
  'IQ', // Iraq
  'JO', // Jordan
  'KW', // Kuwait
  'LB', // Lebanon
  'LY', // Libya
  'MA', // Morocco
  'MR', // Mauritania
  'OM', // Oman
  'PS', // Palestine
  'QA', // Qatar
  'SA', // Saudi Arabia
  'SD', // Sudan
  'SO', // Somalia
  'SY', // Syria
  'TN', // Tunisia
  'YE', // Yemen
  'DJ', // Djibouti
  'KM', // Comoros
];

const EU_COUNTRIES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  // EEA + closely associated
  'NO', // Norway
  'IS', // Iceland
  'LI', // Liechtenstein
  'CH', // Switzerland
  'GB', // United Kingdom
];

const US_CODES = ['US', 'CA'];

export function getRegionFromCountryCode(
  countryCode: string | null,
): VisitorRegion {
  if (!countryCode) return 'Others';
  const code = countryCode.toUpperCase();
  if (US_CODES.includes(code)) return 'U.S.';
  if (GCC_COUNTRIES.includes(code)) return 'GCC';
  if (EU_COUNTRIES.includes(code)) return 'EU';
  return 'Others';
}

/**
 * ISO 3166-1 alpha-2 country code from the VISITOR_COUNTRY cookie the
 * middleware sets off Cloudflare/Vercel geo headers. Null on the server or
 * when geo detection didn't run (e.g. localhost).
 */
export function getCountryFromCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    /(?:^|;\s*)VISITOR_COUNTRY=([A-Za-z]{2})(?:;|$)/,
  );
  return match ? match[1].toUpperCase() : null;
}

export function getRegionFromCookie(): VisitorRegion {
  if (typeof document === 'undefined') return 'Others';
  const cookies = document.cookie.split(';');
  const regionCookie = cookies.find((c) =>
    c.trim().startsWith('VISITOR_REGION='),
  );
  if (!regionCookie) return 'Others';
  const value = regionCookie.split('=')[1]?.trim();
  if (
    value === 'U.S.' ||
    value === 'EU' ||
    value === 'GCC' ||
    value === 'Others'
  ) {
    return value;
  }
  return 'Others';
}
